import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';

import { AuthService, AppSettingsService, ClaimsService, MenuService } from '../core/services';
import { FormHelperService } from "../core/services/form-helper.service";

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {
    public loginFrom: FormGroup;
    public loginError: string;
    public processing: boolean = false;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private claimsService: ClaimsService,
        private menuService: MenuService,
        private appSettingsService: AppSettingsService,
        private formHelperService: FormHelperService) { }

    ngOnInit() {
        this.loginFrom = this.formBuilder.group({
            username: ['', [Validators.required, CustomValidators.email]],
            password: ['', [Validators.required]]
        });
        this.processing = false;
    }

    login(event: any): void {
        event.preventDefault();

        this.processing = true;
        this.loginError = '';
        this.authService.login(this.loginFrom.value).subscribe(
            response => {
                if (response) {
                    this.authService.getClaims().subscribe(() => {
                        this.authService.getFilters().subscribe(() => {
                            let route = this.menuService.getDefaultPageUrl(this.claimsService.getUserTypeId());
                            this.router.navigate([route]);
                        });
                    }, () => { this.processing = false; });
                }
                else {
                    this.loginError = "The user name or password is incorrect."
                    this.processing = false;
                };
            },
            error => {
                if (error !== null && error.status === 0) {
                    this.loginError = "This user was not found!";
                } else {
                    if (error !== null && ((error._body || null) !== null)) {
                        let body = JSON.parse(error._body);
                        this.loginError = body.error_description || '';
                    }
                }
                this.processing = false;
            },
            () => { });
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.loginFrom, controlName, validator)
    }

    onForgotPassword(event) {
        event.preventDefault();
        event.stopPropagation();
        this.router.navigate([this.appSettingsService.ForgotPassword]);
    }
}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts